import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Info } from 'lucide-react';
import { useIncident } from 'components/IAP/hooks/incidentHooks';

export function CardIncidentName() {
  const { data: incident } = useIncident();

  return (
    <Card className="tw:w-1/3 tw:bg-transparent" size="sm">
      <CardHeader>
        <CardTitle className="tw:flex tw:items-center tw:justify-between">
          <span>1. Incident Name</span>
          <Tooltip>
            <TooltipTrigger>
              <Info size={16} />
            </TooltipTrigger>
            <TooltipContent>
              <p>
                This section is read-only. It is automatically filled from the
                incident name.
              </p>
            </TooltipContent>
          </Tooltip>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p>{incident?.name}</p>
      </CardContent>
    </Card>
  );
}
